// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","dummy":"App_dummy__XLe58"};